exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.card-footer {\n    overflow: visible !important;\n    position: relative; /* 让 tooltip 的 absolute 定位相对这层 */\n}\n", "", {"version":3,"sources":["D:/a/8/s/AFBPlay/src/components/DashboardOperation.vue"],"names":[],"mappings":";AACA;IACI,6BAA6B;IAC7B,mBAAmB,CAAC,iCAAiC;CACxD","file":"DashboardOperation.vue","sourcesContent":["\n.card-footer {\n    overflow: visible !important;\n    position: relative; /* 让 tooltip 的 absolute 定位相对这层 */\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-08c6a52e","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/DashboardOperation.vue
// module id = IWUB
// module chunks = 2